export const privacyPolicyHeTranslations = {
  privacy_policy: 'מדיניות פרטיות',
  last_updated: 'עודכן לאחרונה',
  privacy_policy_date: '23 בנובמבר 2025',
  go_back: 'חזור',
  privacy_policy_content: {
    company_name: 'Intera-AI',
    system_name: 'Intera - Internal Relationship Management',
    introduction: {
      title: 'מבוא',
      welcome:
        'ברוכים הבאים למערכת Intera ("המערכת") של חברת Intera-AI Ltd. ("החברה").',
      terms:
        'השימוש במערכת כפוף לתנאי השימוש במערכת ולמדיניות פרטיות זו שהיא חלק מהם.',
      important_notice:
        'נא קראו בעיון מדיניות פרטיות זו ואת תנאי השימוש במערכת בטרם תשתמשו בה, שכן הם מהווים חוזה מחייב בינכם לבין החברה ושימושכם במערכת מעיד על הסכמתכם להם.',
      updates_notice:
        'נא גם חזרו וקראו אותם מעת לעת משום שתנאיהם עשויים להשתנות (אנו נדאג לעדכן בכותרת מדיניות פרטיות זו ותנאי שימוש את מועד העדכון האחרון שנעשה בהם).',
      agreement_notice:
        'ככל שאינכם מסכימים לתנאי מדיניות פרטיות זו עליכם להימנע מכל שימוש במערכת.',
    },
    information_collection: {
      title: 'מסירה ואיסוף של מידע אישי',
      system_access: {
        title: 'גישה למערכת',
        content: 'הגישה למערכת נעשית באמצעות חשבונות משתמשים.',
      },
      user_accounts: {
        title: 'חשבונות משתמשים מוקצים על ידי הארגון בו המשתמשים עובדים:',
        admin_user:
          'משתמש מנהל מטעם הארגון שהתקשר עם החברה ("משתמש מנהל") הוא שקובע (בהתאם לכמות הרישיונות שנרכשה על ידי הארגון) אלו חשבונות משתמשים יוקמו, את השיוך הארגוני ואת הרשאות השימוש של כל משתמש.',
        account_management:
          'מחיקה, הוספה או שינוי הרשאות משתמשים נעשים על ידי משתמש מנהל, באמצעות כלי ניהול שבמערכת או באמצעות מתן הנחיות לחברה.',
        required_info:
          "לצורך הקמת חשבון, הארגון מספק לחברה שם ושם משפחה כתובת דואר אלקטרוני, מס' טלפון נייד, מחלקה, תת מחלקה, תפקיד ומנהל ישיר.",
        profile_photos:
          'משתמשים יכולים, ככל שהם מעוניינים בכך, להעלות למערכת תמונה לפרופיל האישי שלהם.',
      },
      admin_permissions:
        'למשתמש מנהל, הרשאות גישה המאפשרות לו לראות גישה למערכת ושימוש בה שנעשו על ידי משתמשים במערכת, זאת ללא אפשרות לראות תוכן השימושים, אלא אם המשתמש שיתף את המשתמש המנהל בתכנים.',
      direct_manager:
        'למשתמש שהוגדר (על ידי המשתמש המנהל) כמנהל הישיר של משתמשים אחרים אפשרות לראות פעולות שנעשו על ידי משתמשים שהוא מוגדר כמנהל הישיר שלהם.',
      content_monitoring:
        'החברה אינה עוקבת אחר משתמשים והיא מנטרת תכנים שמשתמשים מעלים למערכת.',
      usage_data:
        'החברה אוספת מידע בקשר עם השימוש במערכת באופן אגרגטיבי או סטטיסטי (ללא מידע מזהה) לצורך תפעול ושיפור המערכת.',
      security_data:
        'החברה אוספת מידע בקשר עם גישה וניסיונות גישה למערכת ושימוש במערכת לצרכי אבטחה ואכיפת תנאי השימוש.',
    },
    information_usage: {
      title: 'שימוש במידע',
      intro: 'החברה תשתמש במידע שיוחזק אצלה למטרות הבאות:',
      system_provision: 'אספקת המערכת.',
      user_support:
        'מענה לפניות משתמשים, לרבות משתמש מנהל ונציגי הארגון שהתקשר עימה לשימוש במערכת.',
      statistics:
        'לשימושים סטטיסטיים ואח\' שאינם מזוהים עימך (כגון: שיפור המערכת, הוספת תכנים וכלים, שינויים וכיו"ב).',
      legal_compliance: 'ציות להוראות החוק, התקנות והרגולציה.',
      legal_procedures:
        'ניהול הליכים משפטיים ובירור עניינים, טענות ודרישות שעלולות להביא להליכים משפטיים.',
      fraud_prevention: 'מניעת הונאות, מניעת נזק לגוף או לרכוש.',
      security: 'אבטחה, מניעה, בירור והתמודדות עם אירועי אבטחה ואירועי סייבר.',
    },
    information_sharing: {
      title: 'מסירת מידע לספקים של החברה לצורך אספקת שירותים והעברת מידע',
      suppliers:
        'מסירת מידע לספקים של החברה או לחברות קשורות לחברה תעשה לצורך אספקת המערכת בלבד ותוך שאותם צדדים מחויבים לשמור על סודיות ולהשתמש במידע רק לצורך אספקת השירותים.',
      data_transfer: {
        title: 'העברת מידע',
        no_sale: 'החברה אינה מוכרת או משכירה מידע אישי לצדדים שלישיים.',
        no_transfer:
          'החברה לא תעביר מידע אישי לצדדים שלישיים ללא הסכמת נושאי המידע, למעט: במקרים כמפורט להלן:',
        admin_instructions: 'בהתאם להנחיות המשתמש המנהל.',
        legal_requirements:
          'קיום הוראת דין (דין לרבות הוראות והנחיות רגולציה).',
        court_orders: 'קיום צו שיפוטי, הנחיה או הוראה של רשות מוסמכת.',
        business_reorganization:
          'במסגרת ארגון מחדש, מכירת מניות או פעילות השקעה בחברה ובסמוך לקראת התקשרות לכל אחד מהצרכים האמורים.',
        legal_proceedings: 'לצורך הליכים משפטיים או מנהליים.',
        harm_prevention:
          'ככל שלדעת החברה מסירה עשויה לסייע למניעת נזק לך או לאחרים.',
        affiliated_companies:
          'לחברות אם, חברות בנות, חברות קשורות לחברה במסגרת מיזוג או ארגון מחדש של פעילות החברה וחברות קשורות.',
      },
    },
    user_rights: {
      title: 'עיון תיקון והתנגדות',
      access_requests:
        'פניות לעיון במידע, לתיקונו או למחיקתו יש לעשות למשתמש המנהל או לנציג הארגון.',
      company_response:
        'הואיל והחברה מחזיקה מידע אישי עבור הארגון לצורך אספקת המערכת למשתמשיו החברה תפעל, במענה לפניות לעיון, לתיקון או למחיקת מידע בהתאם להנחיות המשתמש המנהל.',
    },
    information_security: {
      title: 'אבטחת מידע',
      content_1:
        'החברה מיישמת אמצעי אבטחה פיזיים, לוגיים, ארגוניים וטכניים המקובלים בתעשייה למניעת גישה לא מורשית, שימוש לרעה, אובדן או שינוי מידע.',
      content_2:
        'בין היתר: בקרות גישה והרשאות, הצפנת תקשורת (TLS), ניטור אירועים, גיבויים, בדיקות חדירות תקופתיות, מדיניות סיסמאות ועוד.',
      content_3:
        'למרות מאמצינו, אין מערכת חסינה לחלוטין. במקרה של אירוע אבטחה חמור הכולל סיכון ממשי לפרטיותכם, נפעל בהתאם לדין ונעדכן את הארגון/המשתמשים כפי שנדרש.',
      content_4:
        'הערה: החברה אינה מוסמכת כיום לפי תקן ISO 27001, והעדרה של הסמכה זו אינו מפחית ממאמצי האבטחה שאנו מיישמים בפועל.',
    },
    policy_scope: {
      title: 'לאיזה מידע המדיניות חלה',
      content_1:
        'המדיניות חלה על כל שימוש במערכת (אפליקציה, דפדפן, ממשקי API, מערכות ניהול) וכן על פניות תמיכה, דיוור או תקשורת אחרת מולנו.',
      content_2:
        "המדיניות אינה חלה על מדיניות פרטיות של הארגון, או על מערכות/שירותים צד ג' שהארגון מפעיל ומשלב בעצמו (כגון מערכות HR, כלי BI וכו').",
    },
    policy_changes: {
      title: 'שינויים למדיניות פרטיות זו',
      update_rights: 'החברה שומרת על זכותה לעדכן מעת לעת מדיניות פרטיות זו.',
      notification:
        'עדכון מדיניות פרטיות יעשה בהודעה מוקדמת, אלא אם העדכון הוא לטובת המשתמש, או על מנת להתאים המדיניות לשינויים שיבואו בדין שאז יכול שהשינוי יהיה מידי.',
      continued_use:
        'המשך שימוש במערכת לאחר שינוי מדיניות הפרטיות יעיד על הסכמה לשינוי, ובכל מקרה של אי הסכמה יש להפסיק ולהשתמש במערכת.',
    },
    children_minors: {
      title: 'ילדים וקטינים',
      content_1:
        'השירות אינו מיועד לילדים מתחת לגיל 13, ואין בכוונתנו לאסוף מידע מילדים בגיל זה ביודעין.',
      content_2:
        'אם נלמד כי אספנו מידע מילד מתחת לגיל 13 ללא הסכמת ההורה/האפוטרופוס כנדרש – נמחקוּ בהקדם האפשרי. פנו אלינו אם אתם סבורים שאירע מקרה כזה.',
    },
    ownership_changes: {
      title: 'שינויי בעלות וארגון מחדש',
      content_1:
        'במקרה של מיזוג, רכישה, מכירת נכסים או שינוי שליטה בחברה, מידע אישי עשוי להועבר לישות החדשה, בכפוף להתחייבותה להמשיך לקיים את תנאי מדיניות זו או תנאים מחמירים יותר.',
    },
    documentation: {
      title: 'תיעוד וגרסאות קודמות',
      content_1:
        'נשמור תיעוד של גרסאות מדיניות קודמות ונעמידו לרשות הארגון לפי בקשתו.',
      content_2:
        'במקרה של סתירה בין גרסה אנגלית לגרסה העברית – הגרסה העברית היא המחייבת (אלא אם הוסכם אחרת בכתב עם הארגון).',
    },
    contact: {
      title: 'יצירת קשר',
      content_1:
        'לשאלות, בקשות או תלונות בנושאי פרטיות ניתן לפנות אלינו בדוא״ל team@intera-ai.io. נשיב בהקדם האפשרי ולא יאוחר מהמסגרת הקבועה בדין.',
    },
  },
} as const;
